import * as types from './mutation-types';

export default {
  [types.SET_CSOSN_COLLECTION](state, payload) {
    state.csosnCollection = payload;
  },
};
